<template>
  <div style="padding: 10px">
    <el-table
      :data="resultList"
      stripe
      :header-cell-style="{ color: '#fff' }"
      :row-class-name="tableRowClassName"
       max-height="250"
    >
      <el-table-column width="100" label="序号" align="center" type="index" />
      <el-table-column
        label="标题"
        align="center"
        :label-style="{ color: '#c88626' }"
        prop="title"
        show-overflow-tooltip
      />
      <el-table-column
        label="时间"
        align="center"
        prop="updateTime"
        width="180"
      />
      <el-table-column
        width="100"
        label="操作"
        align="center"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            icon="el-icon-edit"
            @click="openDialog(scope.row.id)"
          >
            详情
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total > 0"
      :pageSizes="[3]"
      :total="total"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      @pagination="getInfoList"
    />
    <!--    弹框-->
    <div id="dialog">
      <el-dialog
        width="80%"
        title="航行通告"
        center
        @close="closeDialog()"
        v-if="isShow"
        :visible.sync="isShow"
        append-to-body
        :destroy-on-close="true"
        style="top: 115px; left: 130px"
      >
        <!--        显示内容容器-->
        <div id="html_container" style="width: 100%; height: 100%" />
      </el-dialog>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["isToken"],
  data() {
    return {
      BASE_URL: "http://cctv.hbrytech.cn:2123/prod-api/",
      isShow: false, // 控制弹框
      resultList: [],
      loading: true,
      total: 0,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
      },
    };
  },
  created() {},
  methods: {
    // 航行通告
    getInfoList() {
      console.log(this.isToken, "isTokenisToken");
      axios({
        url: this.$root.BASE_URL + "/work/notice/ntm",
        method: "get",
        params: this.queryParams,
        headers: {
          authorization: this.isToken,
        },
      }).then((res) => {
        console.log(res, "123456");
        this.resultList = res.data.rows;
        this.total = res.data.total;
      });
    },
    openDialog(id) {
      // 开启弹框
      this.isShow = true;
      this.$nextTick(() => {
        // 请求后端获取 详细内容
        axios({
          url: this.$root.BASE_URL + `/work/notice/ntm/${id}`,
          method: "get",
          headers: {
            authorization: this.isToken,
          },
        }).then((res) => {
          let dialogDom = document.querySelector("#html_container");
          dialogDom.insertAdjacentHTML("afterbegin", res.data.data.content);
        });
      });
    },
    closeDialog() {
      // 关闭弹框
      this.isShow = false;
    },
    tableRowClassName({ row, rowIndex, store }) {
      console.log(rowIndex, "rowIndexrowIndex");
      if (rowIndex % 2 == 1) {
        return "stripe-row"; // 偶数行（索引为奇数）应用这个类
      }
    },
  },
};
</script>
<style>
.el-dialog {
  /* 添加边框样式 */
  border: 10px solid #43b1d3; /* 你可以设置你想要的边框样式 */
  border-radius: 4px; /* 可选：添加边框圆角 */
}

.el-dialog__header {
  background-color: #e1e6ed;
}
.el-dialog__title {
  font-weight: 800;
}
/* .customer-table th {
  border: none;
}
.customer-table td,
.customer-table th.is-leaf {
  border: none;
}
表格最外边框 .el-table--border,
.el-table--group {
  border: none;
}
头部边框 .customer-table thead tr th.is-leaf {
  border: 1px solid #ebeef5;
  border-right: none;
} */
/* .el-table .stripe-row {
  background-color: red !important;
} */
</style>
